export const SpayOrNeuter = {
  Yes: 'yes',
  No: 'no',
  BackBtn: 'back-btn',
} as const;
